export default {
  getCartonSymbol: (state) => state.cartonSymbol,
};
